

/* eslint-disable class-methods-use-this */
import { IAnnouncementRes, ICreateAnnouncement } from '../models/trainee-course.model';
import getService from './getService';
import postService from './postService';

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://20.126.75.78/naptin/api/v1/';

const INITIATEPAYMENT = 'payments/initiate';
const CONFIRMPAYMENT ='payments/confirm';

class PaymentService {
  
  
  async inititatePayment(data: any) {
    const response = await postService.post( `${CONFIG_API_URL}${INITIATEPAYMENT}`, data);
    return response.data;
  }
  async confirmPayment(data: any) {
    const response = await postService.post( `${CONFIG_API_URL}${CONFIRMPAYMENT}`, data);
    return response.data;
  }
 
}

export default new PaymentService();
